import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ProtectedRoute({ children, allowedRoles }) {
  const { user, role, loading } = useAuth();
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!token || !user) {
    return <Navigate to="/login" />;
  }

  // Still on a temporary password (e.g. just created by an admin) — force
  // through /change-password before anything else, even a direct URL visit
  // or a page refresh, so this can't be bypassed once logged in.
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/login" />;
  }

  return children;
}

export default ProtectedRoute;
